import { groupBy, orderBy } from "lodash";
import { Item__Atividades, ItemPropriedades } from "../../../../../../../services/atividades/GET";
import { dummy_tipos_uso, extrairUnidade } from "../../../../linhaDoTempo/components/cadastro/components/addInsumo/meta";
import { estruturaTodasAtvs, obterCodMedidaInoculante } from "../../atvsTodas/meta/estrutura_todas_atvs";
import { estruturaPlanejamentoInsumos } from "../../planejamentoInsumos/meta";
import { obterCodInsumo } from "../../../../linhaDoTempo/components/cadastro/components/executada/components/execucoesTable/meta";
import { typeInsumoAdd } from "../../../../linhaDoTempo/components/cadastro";
import { normalizarQuantidadeInsumos, viewQuantidadeInsumos } from "./normalizar";
import { numeroMilhar } from "../../../../../../../utils";


export type typeInsumos = {
    insumo_nome: string;
    quantidade_total_view: string;
}

export type typeEstruturaCompraInsumos = {
    cod_propriedade: number;
    nome_propriedade: string;
    insumos: typeInsumos[];
};


export function estruturaCompraInsumos(
    data_atividades: Item__Atividades[],
    data_propriedades: ItemPropriedades[],
    cod_propriedade_selecionada: number,
    gerar_por_propriedade: boolean
): typeEstruturaCompraInsumos[] | typeInsumos[] {

    if (!gerar_por_propriedade) {
        return estruturaCompraInsumosMesclados(data_atividades, data_propriedades, cod_propriedade_selecionada);
    }

    const estrutrua_insumos = estruturaPlanejamentoInsumos(data_atividades, data_propriedades, cod_propriedade_selecionada, null, null);

    const add_info_propriedade_talhao = (estrutrua_insumos ?? []).map(i => {
        return {
            ...i,
            lista_insumos_por_talhao: i.lista_insumos_por_talhao.map(j => {
                return {
                    lista_insumos: j.lista_insumos.map(k => {
                        return {
                            ...k,
                            nome_talhao: j.nome_talhao,
                            cod_talhao: j.cod_talhao,
                            nome_propriedade: i.nome_propriedade,
                            cod_propriedade: i.cod_propriedade,
                            ref_name: `${k.cod_insumo}_____${k?.insumo_nome}_____${k.cod_medida}_____${k.cod_tipo}`,
                        }
                    })
                }
                //@ts-ignore
            }).map(l => l.lista_insumos).flat()
        }
    })

    const estrutura_compras: typeEstruturaCompraInsumos[] = add_info_propriedade_talhao.map(i => {

        const agrupar_insumos = groupBy(i.lista_insumos_por_talhao, 'ref_name');
        const estrutura_insumos = Object.entries(agrupar_insumos).map(([_key, insumos]) => {

            const normalizar_qtds = (insumos ?? []).map(i => {
                const cod_medida = i.cod_tipo === 8 ? obterCodMedidaInoculante(extrairUnidade(i.calculo_dosagem)) : i.cod_medida;
                const norm = normalizarQuantidadeInsumos(i.quantidade, cod_medida);
                return {
                    ...i,
                    quantidade_normalizada: norm.quantidade,
                    nome_medida_normalizada: norm.medida_normalizada,
                    cod_medida_normalizada: norm.cod_medida_normalizada,
                }
            })
            const qtd_total = normalizar_qtds.reduce((acc, i) => acc + i.quantidade_normalizada, 0);
            return {
                // cod_insumo: insumos[0].cod_insumo,
                insumo_nome: insumos[0].insumo_nome,
                // insumos: normalizar_qtds,
                // quantidade_total: numeroMilhar(qtd_total),
                quantidade_total_view: viewQuantidadeInsumos(qtd_total, normalizar_qtds[0].cod_medida_normalizada),
                // medida: normalizar_qtds[0].nome_medida_normalizada,
            }
        })

        return {
            nome_propriedade: i.nome_propriedade,
            cod_propriedade: i.cod_propriedade,
            insumos: estrutura_insumos
        }
    })

    return estrutura_compras ?? [];
};


export function estruturaCompraInsumosMesclados(
    data_atividades: Item__Atividades[],
    data_propriedades: ItemPropriedades[],
    cod_propriedade_selecionada: number
): typeInsumos[] {

    const estrutrua_insumos = estruturaPlanejamentoInsumos(data_atividades, data_propriedades, cod_propriedade_selecionada, null, null);

    const add_info_propriedade_talhao = (estrutrua_insumos ?? []).map(i => {
        return {
            lista_insumos_por_talhao: i.lista_insumos_por_talhao.map(j => {
                return {
                    lista_insumos: j.lista_insumos.map(k => {
                        return {
                            ...k,
                            nome_talhao: j.nome_talhao,
                            cod_talhao: j.cod_talhao,
                            nome_propriedade: i.nome_propriedade,
                            cod_propriedade: i.cod_propriedade,
                            ref_name: `${k.cod_insumo}_____${k?.insumo_nome}_____${k.cod_medida}_____${k.cod_tipo}`,
                        }
                    })
                }
            })
        }
        //@ts-ignore
    }).map(i => i.lista_insumos_por_talhao).flat()?.map(i => i.lista_insumos).flat();

    const agrupado_por_ref = groupBy(add_info_propriedade_talhao, 'ref_name');

    const estrutura_compras = Object.entries(agrupado_por_ref).map(([_ref_name, insumos]) => {
        const normalizar_qtds = (insumos ?? []).map(i => {
            const cod_medida = i.cod_tipo === 8 ? obterCodMedidaInoculante(extrairUnidade(i.calculo_dosagem)) : i.cod_medida;
            const norm = normalizarQuantidadeInsumos(i.quantidade, cod_medida);
            return {
                ...i,
                quantidade_normalizada: norm.quantidade,
                nome_medida_normalizada: norm.medida_normalizada,
                cod_medida_normalizada: norm.cod_medida_normalizada,
            }
        })
        const qtd_total = normalizar_qtds.reduce((acc, i) => acc + i.quantidade_normalizada, 0);
        return {
            insumo_nome: insumos?.[0]?.insumo_nome,
            quantidade_total_view: viewQuantidadeInsumos(qtd_total, normalizar_qtds[0].cod_medida_normalizada),
        }
    });

    return estrutura_compras ?? [];
};